import React from "react";
import { useLocalization } from "@i18n";
import { GeneralDashboardCard } from "./GeneralDashboardCard";
import { GeneralDashboardFieldStack } from "./GeneralDashboardFieldStack";
import { DAM_GEOMETRY_FIELDS_SUBSET } from "../utils/generalFieldConfigs";

interface GeneralGeometryCardProps {
  data: Record<string, unknown> | null;
  onMenuClick: () => void;
}

export const GeneralGeometryCard: React.FC<GeneralGeometryCardProps> = ({
  data,
  onMenuClick,
}) => {
  const { translate } = useLocalization();

  const fields = DAM_GEOMETRY_FIELDS_SUBSET.map((field) => ({
    labelKey: field.labelKey,
    value: data ? data[field.name] : null,
  }));

  return (
    <GeneralDashboardCard
      title={translate("general.dashboard.geometry.title")}
      titleVariant="large"
      onMenuClick={onMenuClick}
      className="h-full"
      menuTestId="more-options-geometria-do-maci-o"
    >
      <GeneralDashboardFieldStack fields={fields} />
    </GeneralDashboardCard>
  );
};
